/**
 * The Grid Status chip: Draft, Open, Locked, Live, Final or Void. Color is
 * always paired with the word, never the only signal.
 */
import { cn } from "@sportsmet/ui";
import type { ReactNode } from "react";

import { squaresGridStatusLabel } from "./squaresCopy";
import type {
  typeSquaresGridState,
  typeSquaresPublishStatus,
} from "./squaresTypes";

export function squaresStatusChipTone(input: {
  gridState: typeSquaresGridState;
  publishStatus: typeSquaresPublishStatus;
}): string {
  if (input.publishStatus === "draft") {
    return "border-dashed border-line-strong bg-surface text-ink-secondary";
  }
  switch (input.gridState) {
    case "open":
      return "border-success bg-success-tint text-ink";
    case "locked":
      return "border-info bg-info-tint text-ink";
    case "live":
      return "border-error bg-error-tint text-ink";
    case "final":
      return "border-line bg-surface-sunken text-ink";
    case "void":
      return "border-disabled-border bg-disabled-bg text-disabled-text";
  }
}

export const SquaresStatusChip = (props: {
  gridState: typeSquaresGridState;
  publishStatus: typeSquaresPublishStatus;
  className?: string | undefined;
}): ReactNode => (
  <span
    data-testid="squares-status-chip"
    data-state={props.publishStatus === "draft" ? "draft" : props.gridState}
    className={cn(
      "inline-flex h-chip-height items-center gap-1 rounded-full border px-3 text-caption",
      squaresStatusChipTone(props),
      props.className,
    )}
  >
    {props.gridState === "live" && props.publishStatus === "published" ? (
      <span
        aria-hidden="true"
        className="h-score-live-dot w-score-live-dot rounded-full bg-error-solid motion-safe:animate-pulse"
      />
    ) : null}
    {squaresGridStatusLabel(props)}
  </span>
);
